(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-accessories"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-accessories')) {
    customElements.define(
      'product-accessories',
      class ProductAccessories extends HTMLElement {
        connectedCallback() {
          this.section = this.closest('.shopify-section, dialog');
          this.section?.addEventListener('variant:update', this.update);
        }

        disconnectedCallback() {
          this.section?.removeEventListener('variant:update', this.update);
        }

        update = (event) => {
          const { data } = event.detail;
          if (data.newProduct) {
            this.dataset.productId = data.newProduct.id;
          } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
            return;
          }

          const next = data.html?.querySelector(`product-accessories[data-block-id="${this.dataset.blockId}"]`);
          if (!next) return;

          this.innerHTML = next.innerHTML;
          this.hidden = next.hidden;
        };
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
